import * as z from "zod/v4";

const SkuMappingSchema = z.object({
  sku: z.string(),
  values: z.array(z.string()),
});

const AdditionalAttributeKeysSchema = z.object({
  additionalAttributeKey1: z.string().nullish(),
  additionalAttributeKey2: z.string().nullish(),
  additionalAttributeKey3: z.string().nullish(),
  additionalAttributeKey4: z.string().nullish(),
  additionalAttributeKey5: z.string().nullish(),
  additionalAttributeKey6: z.string().nullish(),
  additionalAttributeKey7: z.string().nullish(),
  additionalAttributeKey8: z.string().nullish(),
  additionalAttributeKey9: z.string().nullish(),
  additionalAttributeKey10: z.string().nullish(),
});

export const updateCin7CoreIntegration = {
  name: "updateCin7CoreIntegration" as const,
  input: z.object({
    skuMappings: z.array(SkuMappingSchema).optional(),
    locationName: z.string().optional(),
    enableWms: z.boolean().optional(),
    enableOms: z.boolean().optional(),
    saleAttributes: AdditionalAttributeKeysSchema.optional(),
    productAttributes: AdditionalAttributeKeysSchema.optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
